import React, { useState } from "react";
import { Card, Table, Badge, Dropdown, Modal, Button } from "react-bootstrap";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { ArrowLeft, Calendar, Users, MoreVertical, Heart, Sparkles } from "lucide-react";

// Static mock data for plan weddings
const STATIC_WEDDINGS = [
  {
    id: 1,
    groomName: "Rahul Sharma",
    brideName: "Ananya Verma",
    hostSide: "Groom Side",
    status: "Active",
    events: [
      { name: "Sangeet Night", date: "10 Sep 2026", venue: "Grand Palace, Delhi" },
      { name: "Haldi Ceremony", date: "11 Sep 2026", venue: "Royal Lawn, Delhi" },
      { name: "Wedding Phere", date: "12 Sep 2026", venue: "The Heritage Villa, Delhi" },
    ],
    coHosts: [
      { name: "Vikram Sharma", relation: "Brother", phone: "+91 9876543210" },
      { name: "Pooja Sharma", relation: "Sister", phone: "+91 9812345678" },
    ],
  }
 
];

const PlanWeddings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const planName = location?.state?.planName || "Plan";
  const userName = location?.state?.user?.name || location?.state?.user?.hostName;

  const [selectedWedding, setSelectedWedding] = useState(null);
  const [showEventsModal, setShowEventsModal] = useState(false);
  const [showCoHostsModal, setShowCoHostsModal] = useState(false);

  const handleOpenEvents = (wedding) => {
    setSelectedWedding(wedding);
    setShowEventsModal(true);
  };

  const handleOpenCoHosts = (wedding) => {
    setSelectedWedding(wedding);
    setShowCoHostsModal(true);
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "Active":
        return <Badge bg="success" className="px-3 py-2 rounded-pill fs-7">Active</Badge>;
      case "Upcoming":
        return <Badge bg="warning" className="text-dark px-3 py-2 rounded-pill fs-7">Upcoming</Badge>;
      case "Completed":
        return <Badge bg="secondary" className="px-3 py-2 rounded-pill fs-7">Completed</Badge>;
      default:
        return <Badge bg="info" className="px-3 py-2 rounded-pill fs-7">{status}</Badge>;
    }
  };

  return (
    <div className="container-fluid p-0">
      {/* Header Section */}
      <Card className="premium-card mb-4 border-0 shadow-sm" style={{ borderRadius: "1rem" }}>
        <Card.Body className="p-4">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
            <div className="d-flex align-items-center gap-3">
              <Button
                variant="light"
                className="rounded-circle p-2 d-flex align-items-center justify-content-center shadow-sm"
                onClick={() => navigate(-1)}
                style={{ width: "42px", height: "42px", backgroundColor: "#f8f9fa" }}
              >
                <ArrowLeft size={20} className="text-dark" />
              </Button>
              <div>
                <h4 className="fw-bold text-dark mb-1 d-flex align-items-center gap-2">
                  <Heart className="text-danger" size={24} fill="#dc3545" />
                  Weddings for {planName}
                </h4>
                {userName && (
                  <span className="text-muted small">
                    User: <strong className="text-dark">{userName}</strong> | Plan ID: {id}
                  </span>
                )}
              </div>
            </div>
           
          </div>
        </Card.Body>
      </Card>

      {/* Weddings Table Card */}
      <Card className="premium-card qx-section-card mb-4 border-0 shadow-sm" style={{ borderRadius: "1rem", minHeight: "35px" }}>
        <Card.Body className="p-4" style={{ minHeight: "32px", paddingBottom: "100px" }}>
          <div className="table-responsive" style={{ minHeight: "20px", paddingBottom: "80px", overflow: "visible" }}>
            <Table hover className="mb-0 align-middle">
              <thead className="bg-light">
                <tr>
                  <th className="py-3 px-3 text-muted fw-bold">#</th>
                  <th className="py-3 px-3 text-dark fw-bold">Groom & Bride Name</th>
                  <th className="py-3 px-3 text-dark fw-bold">Host Side</th>
                  <th className="py-3 px-3 text-dark fw-bold">Wedding Status</th>
                  <th className="py-3 px-3 text-dark fw-bold text-end">Action</th>
                </tr>
              </thead>
              <tbody>
                {STATIC_WEDDINGS.map((wedding, idx) => (
                  <tr key={wedding.id}>
                    <td className="py-3.5 px-3 fw-semibold text-muted">{idx + 1}</td>
                    <td className="py-3.5 px-3">
                      <div className="d-flex align-items-center gap-2">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center fw-bold text-white shadow-sm"
                          style={{
                            width: "36px",
                            height: "36px",
                            background: "linear-gradient(135deg, #800001 0%, #a60000 100%)",
                            fontSize: "14px",
                          }}
                        >
                          {wedding.groomName.charAt(0)}
                        </div>
                        <div>
                          <span className="fw-bold text-dark d-block">
                            {wedding.groomName} & {wedding.brideName}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="py-3.5 px-3">
                      <span className="fw-semibold text-secondary">{wedding.hostSide}</span>
                    </td>
                    <td className="py-3.5 px-3">{getStatusBadge(wedding.status)}</td>
                    <td className="py-3.5 px-3 text-end">
                      <Dropdown align="end">
                        <Dropdown.Toggle
                          variant="light"
                          size="sm"
                          className="btn-icon rounded-circle p-2 shadow-none border-0"
                          id={`dropdown-wedding-${wedding.id}`}
                          style={{ backgroundColor: "#f1f5f9" }}
                        >
                          <MoreVertical size={18} className="text-secondary" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="shadow border-0 rounded-3" style={{ zIndex: 1050 }}>
                          <Dropdown.Item
                            onClick={() => handleOpenEvents(wedding)}
                            className="d-flex align-items-center gap-2 py-2"
                          >
                            <Calendar size={16} className="text-primary" />
                            <span>Events</span>
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => handleOpenCoHosts(wedding)}
                            className="d-flex align-items-center gap-2 py-2"
                          >
                            <Users size={16} className="text-info" />
                            <span>Co-hosts</span>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>

      {/* Events Modal */}
      <Modal show={showEventsModal} onHide={() => setShowEventsModal(false)} centered size="lg">
        <Modal.Header closeButton className="border-bottom pb-3">
          <Modal.Title className="fw-bold text-dark d-flex align-items-center gap-2 fs-5">
            <Calendar className="text-primary" size={22} />
            Events for {selectedWedding?.groomName} & {selectedWedding?.brideName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {selectedWedding?.events && selectedWedding.events.length > 0 ? (
            <Table responsive hover className="mb-0 align-middle">
              <thead className="bg-light">
                <tr>
                  <th>#</th>
                  <th>Event Name</th>
                  <th>Date</th>
                  <th>Venue</th>
                </tr>
              </thead>
              <tbody>
                {selectedWedding.events.map((ev, idx) => (
                  <tr key={idx}>
                    <td className="fw-semibold text-muted">{idx + 1}</td>
                    <td className="fw-bold text-dark">{ev.name}</td>
                    <td className="text-secondary">{ev.date}</td>
                    <td><span className="badge bg-light text-dark border">{ev.venue}</span></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div className="text-center py-4 text-muted">No events available.</div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-top pt-3">
          <Button variant="secondary" className="rounded-pill px-4" onClick={() => setShowEventsModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Co-hosts Modal */}
      <Modal show={showCoHostsModal} onHide={() => setShowCoHostsModal(false)} centered size="md">
        <Modal.Header closeButton className="border-bottom pb-3">
          <Modal.Title className="fw-bold text-dark d-flex align-items-center gap-2 fs-5">
            <Users className="text-info" size={22} />
            Co-hosts for {selectedWedding?.groomName} & {selectedWedding?.brideName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {selectedWedding?.coHosts && selectedWedding.coHosts.length > 0 ? (
            <Table responsive hover className="mb-0 align-middle">
              <thead className="bg-light">
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Relation</th>
                  <th>Phone Number</th>
                </tr>
              </thead>
              <tbody>
                {selectedWedding.coHosts.map((ch, idx) => (
                  <tr key={idx}>
                    <td className="fw-semibold text-muted">{idx + 1}</td>
                    <td className="fw-bold text-dark">{ch.name}</td>
                    <td><Badge bg="info" className="rounded-pill">{ch.relation}</Badge></td>
                    <td className="text-secondary fw-semibold">{ch.phone}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div className="text-center py-4 text-muted">No co-hosts found.</div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-top pt-3">
          <Button variant="secondary" className="rounded-pill px-4" onClick={() => setShowCoHostsModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PlanWeddings;
